export default __webpack_public_path__ + "static/media/AGE_International_Platform_Manual_V2.b4a73067.pdf";